import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SuccessfulRegisterComponent } from './successful-register.component';



@NgModule({
  declarations: [SuccessfulRegisterComponent],
  imports: [
    CommonModule
  ]
  , exports: [SuccessfulRegisterComponent]
})
export class SuccessfulRegisterModule { }
